import { render, staticRenderFns } from "./ZyroIconControls.vue?vue&type=template&id=63350989&scoped=true&"
import script from "./ZyroIconControls.vue?vue&type=script&lang=js&"
export * from "./ZyroIconControls.vue?vue&type=script&lang=js&"
import style0 from "./ZyroIconControls.vue?vue&type=style&index=0&id=63350989&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63350989",
  null
  
)

export default component.exports